export const LEVEL_TEST_LEVELS = [
  { value: "2", label: "Level 2" },
  { value: "3", label: "Level 3" },
  { value: "4", label: "Level 4" },
  { value: "5", label: "Level 5" },
  { value: "6", label: "Level 6" },
  { value: "7", label: "Level 7" },
  { value: "8", label: "Level 8" },
  { value: "9", label: "Level 9" },
  { value: "10", label: "Level 10" },
];

export function getLevelLabel(level) {
  const normalizedLevel = String(level ?? "1");
  if (normalizedLevel === "1") {
    return "Level 1";
  }
  const matched = LEVEL_TEST_LEVELS.find(
    (item) => item.value === normalizedLevel
  );
  return matched ? matched.label : normalizedLevel;
}

/** 말하기/듣기 유형에서 지시문 미입력 시 서버·등록 폼 기본값 */

export const LEVEL_TEST_QUESTION_TYPES = [
  { value: "short_answer", label: "단답형" },
  { value: "word_sentence", label: "단어/문장" },
  { value: "speaking_listen", label: "말하기/듣기" },
];

export const LEVEL_TEST_STATUSES = [
  { value: "draft", label: "초안" },
  { value: "in_progress", label: "진행 중" },
  { value: "submitted", label: "제출 완료" },
  { value: "under_review", label: "검토 중" },
  { value: "finalized", label: "확정 완료" },
];

export const LEVEL_TEST_OUTCOMES = [
  { value: "pending", label: "대기" },
  { value: "passed", label: "합격" },
  { value: "failed", label: "불합격" },
  { value: "needs_retake", label: "재응시" },
];
